import { sortBy } from 'lodash';

import {
  useFetchMessageTemplates,
  useFetchRecommendationTemplates,
  useFetchTicketTemplates
} from '@/pages/Ticket';

import {
  useCreateTemplate,
  useDeleteTemplate,
  useMutationTemplate
} from './AdministrationTemplates.store';

const useAdministrationTemplates = () => {
  const {
    refetch: refetchTickets,
    isFetching: isFetchingTicketTemplates,
    data: ticketTemplatesData
  } = useFetchTicketTemplates();

  const {
    refetch: refetchRecommendations,
    isFetching: isFetchingRecommendationTemplates,
    data: recommendationTemplatesData
  } = useFetchRecommendationTemplates();

  const {
    refetch: refetchMessages,
    isFetching: isFetchingMessageTemplates,
    data: messageTemplatesData
  } = useFetchMessageTemplates();

  const {
    mutate: updateTemplate,
    error: updateError,
    isSuccess: updateSuccess
  } = useMutationTemplate(
    refetchTickets,
    refetchRecommendations,
    refetchMessages
  );
  const {
    mutate: createTemplate,
    error: createError,
    isSuccess: createSuccess
  } = useCreateTemplate(
    refetchTickets,
    refetchRecommendations,
    refetchMessages
  );

  const { mutate: deleteTemplate } = useDeleteTemplate(
    refetchTickets,
    refetchRecommendations,
    refetchMessages
  );

  // sort template list by template name
  const messageTemplates = sortBy(messageTemplatesData, (template) =>
    template.template_name.toLowerCase()
  );
  const recommendationTemplates = sortBy(
    recommendationTemplatesData,
    (template) => template.template.toLowerCase()
  );
  const ticketTemplates = sortBy(ticketTemplatesData, (template) =>
    template.template_name.toLowerCase()
  );

  return {
    updateTemplate,
    createTemplate,
    deleteTemplate,
    isFetchingTicketTemplates,
    isFetchingRecommendationTemplates,
    isFetchingMessageTemplates,
    messageTemplates,
    recommendationTemplates,
    ticketTemplates,
    // @ts-expect-error ts(2339)
    createError: createError?.response?.data?.detail,
    createSuccess,
    // @ts-expect-error ts(2339)
    updateError: updateError?.response?.data?.detail,
    updateSuccess
  };
};

export default useAdministrationTemplates;
